/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { AddUpdateUserForm } from "../../sub-modules/AddUpdateUserForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { SingleUserData } from "../../redux/Slice/Users/SingleUserSlice";
import { UpdateUser } from "../../utilities/api/user/user-service";
import { ToastContainer, toast } from "react-toastify";

const UpdateUsers = () => {
  const userId = useLocation().state;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const data: any = useAppSelector(
    (state) => state.singleUser.SingleUserDataList
  );

  const initialState = {
    firstName: data?.firstName,
    lastName: data?.lastName,
    roleId: `${data?.userRole?.roleId}`,
    phone: data?.phone,
    email: data?.email,
    gender: data?.gender,
    birthDate: data?.birthDate,
    aadharNumber: data?.aadharNumber,
    isActive: `${data?.isActive}`,
    userImage: data?.userImage,
    addressLine1: data?.address?.addressLine1,
    addressLine2: data?.address?.addressLine2,
    city: data?.address?.city,
    state: data?.address?.state,
    country: data?.address?.country,
    pincode: data?.address?.pincode,
    landmark: data?.address?.landmark,
    id: data?.id,
    userFacilities: data?.userFacilities?.map((item: any) => item.facility.id),
  };

  const [userData, setUserData] = useState(initialState);
  const [submitButton, setSubmitButton] = useState(false);

  useEffect(() => {
    setUserData(initialState);
  }, [data]);

  const HandleSubmit = async (payload: any) => {
    setSubmitButton(true);

    const result = await UpdateUser(userId, payload);
    if (result?.data?.statusCode === 200) {
      navigate("/users");
    } else {
      toast.error(result.response.data.message);
    }
    setSubmitButton(false);
  };

  useEffect(() => {
    dispatch(SingleUserData(userId));
  }, []);
  return (
    <>
      <AddUpdateUserForm
        submitButton={submitButton}
        key={userData.id}
        buttonName="Edit User"
        userData={userData}
        setUserData={setUserData}
        HandleSubmit={HandleSubmit}
      />
      <ToastContainer />
    </>
  );
};
export { UpdateUsers };
